module.exports = __webpack_public_path__ + "img/filigree1.a6b3203e.jpg";